import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export class HoldAndSpinRecord extends SpinRecord {
    public id = "HoldAndSpinRecord";
    public freespinsRemaining: number;
    public freespinsSpun: number;
    public totalFreespins: number;
    public complete: boolean;
    public issuesRetrigger: boolean;

    public getTotalFreespins() {
        return this.freespinsRemaining + this.freespinsSpun;
    }

    public hasBonusSymbols() {
        // TODO: This symbol ID probably won't exist, but I don't think this function is ever called anyway?
        return this.grid.some((reel) => reel.some((symbol) => symbol.indexOf("SS") >= 0));
    }
}
